/* eslint-disable react/prop-types */
import React from 'react';

import CredentialBox from '../../layouts/CredentialsBoxWrapper';
import NewPasswordBox from '../../components/NewPasswordBox';
import newPasswordEnhancer from '../../../common/containers/NewPasswordEnhancer';

const NewPassword = ({ ...props }) => (
  <CredentialBox>
    <NewPasswordBox {...props} />
  </CredentialBox>
);

export default newPasswordEnhancer(NewPassword);



// WEBPACK FOOTER //
// ./src/views/sports-connect/pages/NewPassword/index.js